import { useState } from 'react'

const ActionButtonGradient = ({ 
    variant = 'primary', 
    onClick, 
    children, 
    disabled = false,
    size = 'medium',
    icon = null,
    ...props 
}) => {
    const [isHovered, setIsHovered] = useState(false)

    const gradients = {
        primary: {
            normal: 'linear-gradient(to bottom right, #02B4CC 0%, #0284C7 100%)',
            hover: 'linear-gradient(to bottom right, #028A9B 0%, #026A8C 100%)'
        },
        success: {
            normal: 'linear-gradient(to bottom right, #02A370 0%, #029960 100%)',
            hover: 'linear-gradient(to bottom right, #028558 0%, #027A4E 100%)'
        },
        danger: {
            normal: 'linear-gradient(to bottom right, #CC2B45 0%, #C72744 100%)',
            hover: 'linear-gradient(to bottom right, #9B2235 0%, #8C2030 100%)'
        },
        secondary: {
            normal: 'linear-gradient(to bottom right, #6C757D 0%, #5A6268 100%)',
            hover: 'linear-gradient(to bottom right, #545B62 0%, #4A5258 100%)'
        }
    }

    const sizes = {
        small: {
            padding: '6px 10px',
            fontSize: '12px'
        },
        medium: {
            padding: '8px 12px',
            fontSize: '14px'
        },
        large: {
            padding: '10px 16px',
            fontSize: '16px'
        }
    }

    const currentGradient = gradients[variant] || gradients.primary
    const currentSize = sizes[size] || sizes.medium

    const baseStyle = {
        background: isHovered ? currentGradient.hover : currentGradient.normal,
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        padding: currentSize.padding,
        fontSize: currentSize.fontSize,
        fontWeight: '600',
        cursor: disabled ? 'not-allowed' : 'pointer',
        transition: 'all 0.2s ease',
        opacity: disabled ? 0.6 : 1,
        display: icon ? 'flex' : 'inline-block',
        alignItems: icon ? 'center' : 'normal',
        gap: icon ? '6px' : '0'
    }

    return (
        <button
            onClick={disabled ? undefined : onClick}
            style={baseStyle}
            onMouseEnter={() => !disabled && setIsHovered(true)}
            onMouseLeave={() => !disabled && setIsHovered(false)}
            disabled={disabled}
            {...props}
        >
            {icon && icon}
            {children}
        </button>
    )
}

export default ActionButtonGradient
